import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_supervisor_analytics } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";
import * as routeNames from '../../../routes/routeName'

export const fetchTodaysAnalyticsDetails = createAsyncThunk('fetchTodaysAnalyticsDetails', async (params, { rejectWithValue }) => {
	const { navigate } = params

	try {
		const response = await Axios.get(`${driver_supervisor_analytics}?pharmacy_id=${params.pharmacy_id}`)

		const data = response.data
		return data;

	} catch (error) {
		const errorMessage = error?.response?.data?.data?.error[0] === 'Data can access only supervisor driver'
		const status = error?.response?.status === 404
		if (errorMessage && status) {
			navigate(routeNames.DASHBOARD_PHARMACY)
		}
		return rejectWithValue(error.response)
	}
});